/**
 * Cercles orbitaux (hero + qui suis-je) : auto + accélération au scroll.
 */
export default function initOrbit() {
  const orbitRoots = document.querySelectorAll('[data-orbit-scroll]');
  if (!orbitRoots.length) {
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    orbitRoots.forEach((el) => el.style.setProperty('--orbit-angle', '-90deg'));
    return;
  }

  const angles = Array.from(orbitRoots, (_, i) => -90 + i * 140);
  let lastTs = 0;
  let scrollBoost = 0;
  let lastScrollY = window.scrollY;
  let lastScrollTs = performance.now();

  const idleDegPerSec = 360 / 28;
  const boostDecayPerSec = 2.4;
  const boostFromScroll = 0.35;
  const boostMax = 420;

  const onScroll = () => {
    const now = performance.now();
    const dy = window.scrollY - lastScrollY;
    const dt = Math.max(now - lastScrollTs, 1) / 1000;
    lastScrollY = window.scrollY;
    lastScrollTs = now;

    const velocity = dy / dt;
    scrollBoost += velocity * boostFromScroll * dt;
    scrollBoost = Math.max(-boostMax, Math.min(boostMax, scrollBoost));
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  const tick = (ts) => {
    if (!lastTs) {
      lastTs = ts;
    }
    const dt = Math.min((ts - lastTs) / 1000, 0.05);
    lastTs = ts;

    if (scrollBoost !== 0) {
      scrollBoost *= Math.exp(-boostDecayPerSec * dt);
      if (Math.abs(scrollBoost) < 0.5) {
        scrollBoost = 0;
      }
    }

    const step = (idleDegPerSec + scrollBoost) * dt;
    orbitRoots.forEach((el, i) => {
      angles[i] += step;
      el.style.setProperty('--orbit-angle', `${angles[i].toFixed(2)}deg`);
    });
    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}
